import { CARD_TYPE, IMAGE_CUT } from '@/constants'

export const HORIZONTAL_DEFAULTS = {
  "cardType": CARD_TYPE.HORIZONTAL,
  "imageCut": IMAGE_CUT.BACKDROP,
  "columns": {
    "fullhd": 4,
    "ultrawidescreen": 4,
    "xxl": 4,
    "widescreen": 4,
    "desktop": 3,
    "tablet": 2,
    "mobile": 2,
    "xs": 1.1,
    "base": 1.1
  },
  "scroll": {
    "fullhd": 21,
    "xxl": 21,
    "widescreen": 20,
    "desktop": 21,
    "tablet": 20,
    "mobile": 20
  },
  "params": {
    "paginate": true,
    "itemsPerPage": 10
  },
  "hideEmptyLists": true,
  "hasLazyLoader": true,
  "rewind": true
}

export const TOP_BANNER_DEFAULTS = {
  "cardType": CARD_TYPE.TOP_BANNER,
  "imageCut": IMAGE_CUT.PANORAMA,
  "columns": {
    "fullhd": 1.05,
    "ultrawidescreen": 1.05,
    "xxl": 1.05,
    "widescreen": 1.05,
    "desktop": 1.05,
    "tablet": 1.05,
    "mobile": 1.05,
    "xs": 1.05,
    "base": 1.05
  },
  "scroll": {
    "fullhd": 1,
    "xxl": 1,
    "widescreen": 1,
    "desktop": 1,
    "tablet": 1,
    "mobile": 1
  },
  "params": {
    "paginate": true,
    "itemsPerPage": 10
  },
  "hideEmptyLists": true,
  "hasLazyLoader": true,
  "rewind": true
}

export const EVENTS_DEFAULTS = {
  "cardType": CARD_TYPE.EVENT,
  "imageCut": IMAGE_CUT.SQUARE,
  "columns": {
    "fullhd": 5.5,
    "xxl": 5.5,
    "ultrawidescreen": 4.25,
    "widescreen": 4.25,
    "desktop": 3,
    "tablet": 2.2,
    "mobile": 2.2,
    "xs": 2.1,
    "base": 2.1
  },
  "scroll": {
    "fullhd": 21,
    "widescreen": 20,
    "desktop": 21,
    "tablet": 20,
    "mobile": 20
  },
  "params": {
    "paginate": true,
    "itemsPerPage": 10
  },
  "hideEmptyLists": true,
  "hasLazyLoader": true,
  "rewind": true
}